import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import NodeSvgColor from '../assets/node.svg';

export const NodeColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-nodejs" className={cx('sdkIcon', className)} size={size} {...props}>
    <NodeSvgColor />
  </LegacyIcon>
);
